<template>
    <div v-if="data.date_from && data.date_to">
        <div class="grid _free mtop">
            <div class="inline form-item range">
                <div class="text-item">
                    <span>От</span>
                    <DatePicker :value.sync="data.date_from" @dateUpdate="dateUpdate()"></DatePicker>
                </div>
                <span>&ndash;</span>
                <div class="text-item">
                    <span>До</span>
                    <DatePicker :value.sync="data.date_to" @dateUpdate="dateUpdate()"></DatePicker>
                </div>
            </div>
        </div>
        <div class="grid _free mtop" v-if="data.transactions && data.transactions.length">
            <table class="table-light">
                <thead>
                <td>id</td>
                <td :class="{_ASC: sort.active == 'ctime' && sort.direction == 'ASC', _DESC: sort.active == 'ctime' && sort.direction == 'DESC'}" class="sort" @click="setSort('ctime')"><span>дата</span></td>
                <td :class="{_ASC: sort.active == 'booking' && sort.direction == 'ASC', _DESC: sort.active == 'booking' && sort.direction == 'DESC'}" class="sort" @click="setSort('booking')"><span>букинг</span></td>
                <td :class="{_ASC: sort.active == 'type_text' && sort.direction == 'ASC', _DESC: sort.active == 'type_text' && sort.direction == 'DESC'}" class="sort" @click="setSort('type_text')"><span>тип</span></td>
                <td class="finance">сумма</td>
                <td class="finance">реально заплачено</td>
                <td class="finance">доля парковки</td>
                <td class="finance">наша доля</td>
                <td class="finance">сумма купона</td>
                <td>инициатор</td>
                </thead>
                <tr v-for="(item, index) in transactions" :key="index">
                    <td>{{ item.id }}</td>
                    <td class="nowrap">{{ item.ctime }}</td>
                    <td><router-link v-if="item.booking" class="link2" :to="'/booking/' + item.booking.id">{{ item.booking.number}}</router-link><span v-else>&ndash;</span></td>
                    <td>{{ item.type_text }}</td>
                    <td class="finance" :class="{negative: item.article == 2}">{{ getSum(item.sum, item.article) | finance }}</td>
                    <td class="finance">{{ item.sum_paid | finance }}</td>
                    <td class="finance">{{ item.sum_parking | finance }}</td>
                    <td class="finance">{{ item.sum_app | finance }}</td>
                    <td class="finance">{{ item.sum_coupon | finance }}</td>
                    <td><router-link v-if="item.initiator" class="link2" :to="'/users/' + item.initiator.id">{{ item.initiator.email}}</router-link><span v-else>&ndash;</span></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import DatePicker from '@/components/DatePicker.vue'

    export default {
        props: ['type', 'data'],
        components: {
            DatePicker
        },
        data () {
            return {
                request_status: '',
                sort: {
                    active: 'ctime',
                    direction: 'DESC',
                },
            }
        },
        computed: {
            transactions () {
                let result = this.data.transactions

                let isDate = false
                if (this.sort.active == 'data') isDate = true

                result.sort((a, b) => {
                    let value1 = a[this.sort.active],
                        value2 = b[this.sort.active]

                    if (typeof value1 == 'object') {
                        if (!value1) return 1
                        value1 = value1.number
                    } else if (value1 === '') return 1

                    if (typeof value2 == 'object') {
                        if (!value2) return -1
                        value2 = value2.number
                    } else if (value2 === '') return -1

                    if (isDate) {
                        value1 = new Date(value1)
                        value2 = new Date(value2)
                    }
                    if (this.sort.direction == 'ASC') {
                        if (value1 > value2) return 1
                        if (value1 < value2) return -1
                    } else {
                        if (value1 > value2) return -1
                        if (value1 < value2) return 1
                    }
                    return 0;
                })
                return result
            }
        },
        methods: {
            getSum (sum, article) {
                if (article == 2) sum = sum * -1
                return sum
            },
            setSort (key) {
                if (this.sort.active == key) {
                    if (this.sort.direction == 'DESC') this.sort.direction = 'ASC'
                    else if (this.sort.direction == 'ASC') this.sort.direction = 'DESC'
                } else {
                    this.sort.active = key
                    this.sort.direction = 'DESC'
                }
            },
            dateUpdate () {
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'

                    let url = ''
                    if (this.type == 'parking') {
                        url = 'api/admin/v2/parking/' + this.$route.params.id + '/transaction'
                    } else if (this.type == 'user') {
                        url = 'api/admin/v2/users/' + this.$route.params.id + '/' + this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
                    }

                    this.axios.get(url, {
                        params: {
                            date_from: this.data.date_from,
                            date_to: this.data.date_to
                        }
                    }).then((resp) => {
                        this.request_status = ''
                        this.$emit('updateData', resp.data.response)
                        resolve()
                    }).catch(() => {
                        this.request_status = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            }
        }
    }
</script>